// extracted by mini-css-extract-plugin
export default {"container":"rh","header":"sh","logodesktop":"th","logomobile":"uh","imgcontainer":"vh","slidercontainer":"wh","slick-slider":"xh","slick-initialized":"yh","sliderbox":"zh","headline":"Ah","mainheadline":"Bh","capitalize":"Ch","desc":"Eh","descitalic":"Fh","desccenter":"Gh","descborder":"Hh","subdesc":"Ih","welcomeslide":"Jh","desccard":"Kh","img":"Lh","button":"Mh","buttonskip":"Nh","customPosition":"Oh"};
    if(module.hot) {
      // 1715188237157
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  